/** Default width in pixels of the Task Editor side panel */ export const TaskEditorSidePanelDefaultWidth = 320;
/** Minimum width in pixels the Task Editor side panel can be resized to */ export const TaskEditorSidePanelMinWidth = 200;
/** Maximum width in pixels the Task Editor side panel can be resized to (absolute ceiling) */ export const TaskEditorSidePanelMaxWidth = 704;
/**
 * Minimum width in pixels reserved for the task editor (main) panel.
 * In dialog mode the dialog has a fixed width, so the chat pane can only grow until the
 * main editor panel reaches this minimum.
 */ export const TaskEditorMainPanelMinWidth = 300;
/** Step size in pixels for keyboard-driven resizing of the Task Editor side panel */ export const TaskEditorSidePanelResizeStep = 16;
/**
 * Debounce in milliseconds before a keyboard-driven Task Editor side panel resize is persisted.
 * Coalesces key auto-repeat so holding an arrow key results in a single committed width.
 */ export const TaskEditorSidePanelCommitDebounceMs = 200;
